var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { STACK_ALIGN, STACK_DISTRIBUTION, STACK_GAP, StackView } from "../StackView";
import { INDENT, SPACE_FILL } from "../View";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { LinkButton } from "../controls/LinkButton";
import { Button, BUTTON_VIEW } from "../Button";
import { SPACING_M, SPACING_S } from "../helpers";
import { FilterIcon } from "../AdvancedFilter/svg";
var DEFAULT_TEXTS = {
    clearAll: 'Clear All',
    search: 'Search',
    cancel: 'Cancel'
};
var StyledText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-right: ", ";\n"], ["\n    padding-right: ", ";\n"])), SPACING_S);
var StyledButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-width: 80px;\n"], ["\n    min-width: 80px;\n"])));
var Wrapper = styled(StackView)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", " ", ";\n\n    ", "\n"], ["\n    padding: ", " ", ";\n\n    ",
    "\n"])), SPACING_S, SPACING_M, function (_a) {
    var hasFilters = _a.hasFilters, theme = _a.theme;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        background-color: ", ";\n    "], ["\n        background-color: ", ";\n    "])), hasFilters ? theme.colorHighlightNotification : '#fff');
});
export var SideFilterHeader = function (_a) {
    var valueText = _a.valueText, _b = _a.hasFilters, hasFilters = _b === void 0 ? false : _b, _c = _a.pending, pending = _c === void 0 ? false : _c, _d = _a.disabledSearch, disabledSearch = _d === void 0 ? false : _d, externalTexts = _a.texts, onClearAllClick = _a.onClearAllClick, onSearchClick = _a.onSearchClick, onSearchCancel = _a.onSearchCancel;
    var texts = __assign(__assign({}, DEFAULT_TEXTS), externalTexts);
    var handleClickRightButton = function () {
        pending ? onSearchCancel === null || onSearchCancel === void 0 ? void 0 : onSearchCancel() : onSearchClick === null || onSearchClick === void 0 ? void 0 : onSearchClick();
    };
    return (React.createElement(Wrapper, { spaceFill: SPACE_FILL.all, distribution: STACK_DISTRIBUTION.firstFill, gap: STACK_GAP.s, hasFilters: hasFilters },
        React.createElement(StackView, { align: STACK_ALIGN.center, spaceFill: SPACE_FILL.all, gap: STACK_GAP.s, indentRight: INDENT.s },
            React.createElement(Icon, { src: React.createElement(FilterIcon, null) }),
            React.createElement(StyledText, { truncate: true }, valueText),
            hasFilters && (React.createElement(LinkButton, { disabled: pending, compact: true, onClick: onClearAllClick }, texts.clearAll))),
        React.createElement(StyledButton, { ui: pending ? BUTTON_VIEW.secondary : BUTTON_VIEW.primary, onClick: handleClickRightButton, disabled: disabledSearch }, pending ? texts.cancel : texts.search)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=SideFilterHeader.js.map